import { authAvatarId } from './AuthStore';

export const updateAuthAvatarId = (value) => authAvatarId.update((oldValue) => value);
